export default ({ redirect, route, app }) => {
  if (app.$env.NOZZLE_ENV === 'production') {
    redirect('https://webapp.nozzle.ai' + route.path)
  }
}
